(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pivoli-product-summary"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pv-buy-benefits').forEach(details=>{details.open=window.matchMedia('(min-width:751px)').matches;});
  } catch(e) { console.error(e); }
})();

})();
